export default "__VITE_ASSET__BqaYNOZt__"